import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getStatusText } from '../../../utils';

dayjs.extend(relativeTime);

const STATUS_WORDS =
  /\b(accepted|approved|rejected|withdrawn|negotiated|submitted|pending|denied|closed)\b/gi;

const AVATAR_PALETTES = [
  { background: '#FFF7E6', color: '#FA8C16' },
  { background: '#E6F7FF', color: '#1890FF' },
  { background: '#F9F0FF', color: '#722ED1' },
  { background: '#FFF0F6', color: '#EB2F96' },
  { background: '#F6FFED', color: '#52C41A' },
  { background: '#F5F5F5', color: '#595959' },
];

const STATUS_FOR_STYLE = {
  closed: 'rejected',
  denied: 'rejected',
};

export function getHistoryAvatarStyle(userName) {
  const name = userName || '';
  const index =
    name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % AVATAR_PALETTES.length;
  const palette = AVATAR_PALETTES[index];
  return { backgroundColor: palette.background, color: palette.color };
}

export function stripActorFromHistoryText(text, userName) {
  if (!text) return '';

  let cleaned = text;
  const escapedName = userName ? userName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';

  if (escapedName) {
    cleaned = cleaned.replace(
      new RegExp(`\\s+by vendor\\s+${escapedName}(?=\\s|\\||$)`, 'i'),
      ''
    );
    cleaned = cleaned.replace(
      new RegExp(`\\s+by\\s+${escapedName}(?=\\s|\\||$)`, 'i'),
      ''
    );
  } else {
    cleaned = cleaned.replace(/\s+by vendor\s+[^|]+/i, '');
    cleaned = cleaned.replace(/\s+by\s+[^|]+(?=\s*\|)/i, '');
  }

  return cleaned.replace(/\s{2,}/g, ' ').trim();
}

export function formatHistoryEntry(item) {
  const userName = item?.userName || 'Unknown';
  return {
    mainText: stripActorFromHistoryText(item?.text, userName),
    userName,
  };
}

export function formatHistoryTimestamp(createdAt) {
  const date = dayjs(createdAt);
  if (!date.isValid()) {
    return { relative: '', absolute: '' };
  }
  return {
    relative: date.fromNow(),
    absolute: date.format('DD/MM/YYYY, HH:mm:ss'),
  };
}

export function renderHistoryText(text) {
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;
  let matchIndex = 0;
  const regex = new RegExp(STATUS_WORDS.source, STATUS_WORDS.flags);

  let match = regex.exec(text);
  while (match) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    const word = match[0];
    const statusKey = STATUS_FOR_STYLE[word.toLowerCase()] || word.toLowerCase();
    parts.push(
      <span
        key={`${match.index}-${matchIndex}`}
        className="Quotation_historyStatus"
        style={getStatusText(statusKey)}
      >
        {word}
      </span>
    );

    lastIndex = regex.lastIndex;
    matchIndex += 1;
    match = regex.exec(text);
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length ? parts : text;
}
